import o from "../../../@babel/runtime/helpers/esm/classCallCheck.mjs";
import p from "../../../@babel/runtime/helpers/esm/createClass.mjs";
import a from "../../../@babel/runtime/helpers/esm/inherits.mjs";
import n from "../../../@babel/runtime/helpers/esm/createSuper.mjs";
import * as i from "react";
var l = /* @__PURE__ */ function(e) {
  a(r, e);
  var t = n(r);
  function r() {
    return o(this, r), t.apply(this, arguments);
  }
  return p(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
}(i.Component);
export {
  l as default
};
//# sourceMappingURL=DomWrapper.mjs.map
